/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Solar_PanelsInputs */

const cs_form_solar_panels = /** @type {(inputs: Form_Solar_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solární panely (FTV)`)
};

const en_form_solar_panels = /** @type {(inputs: Form_Solar_PanelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solar panels (FTV)`)
};

/**
* | output |
* | --- |
* | "Solar panels (FTV)" |
*
* @param {Form_Solar_PanelsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_solar_panels = /** @type {((inputs?: Form_Solar_PanelsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Solar_PanelsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_solar_panels(inputs)
	return cs_form_solar_panels(inputs)
});